import {CanActivateFn} from '@angular/router';

export const AccountingManagementGuard: CanActivateFn = (route, state) =>
  localStorage.getItem('gp_accounting_management_enabled') === 'true';
